import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { isNotLoggedGuard } from './core/guards/is-not-logged/is-not-logged.guard';
import { isLoggedGuard } from './core/guards/is-logged/is-logged.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: '',
    canActivate: [isNotLoggedGuard],
    component: AuthLayoutComponent,
    loadChildren: () => import(
      './modules/auth/auth.module'
    ).then(m => m.AuthModule)
  },
  {
    path: 'admin',
    canActivate: [isLoggedGuard],
    component: AdminLayoutComponent,
    loadChildren: () => import(
      './modules/admin/admin.module'
    ).then(m => m.AdminModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
